"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.AssignedAlarmsCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var alarms = state.informationLists.alarms;
  return {
    alarms: alarms
  };
};

exports.mapStateToProps = mapStateToProps;

var AssignedAlarmsCell = function AssignedAlarmsCell(_ref) {
  var assignedAlarms = _ref.cellData,
      alarms = _ref.alarms;
  var alarmElements = assignedAlarms.map(function (alarmId) {
    var alarm = alarms.find(function (al) {
      return al.id === alarmId;
    });

    if (alarm) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "alarm-name"
      }, alarm.name);
    }

    return null;
  });

  if (alarmElements.length) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alarm-names-container"
    }, alarmElements);
  }

  return null;
};

exports.AssignedAlarmsCell = AssignedAlarmsCell;
AssignedAlarmsCell.propTypes = {
  alarms: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  cellData: _propTypes["default"].arrayOf(_propTypes["default"].number)
};
AssignedAlarmsCell.defaultProps = {
  cellData: []
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AssignedAlarmsCell);

exports["default"] = _default;